import * as React from 'react';
import {
  CheckmarkStroke,
  ExclamationStroke,
  InfoStroke,
} from '@bloomberg/media-ui-icons';

import { useSlug } from '../hooks/useSlug';
import { GlobalProps } from '../types';
import { classes } from '../utils';

import styles from './styles.module.css';

export type NotificationBannerProps = GlobalProps & {
  title: string;
  text?: string;
  variant: 'error' | 'success' | 'warning';
  children?: React.ReactNode;
};

export const NotificationIcons: Record<
  NotificationBannerProps['variant'],
  JSX.Element
> = {
  error: <ExclamationStroke />,
  warning: <InfoStroke />,
  success: <CheckmarkStroke />,
};

export const NotificationBanner = React.forwardRef<
  HTMLDivElement,
  NotificationBannerProps
>(function NotificationBannerComponent(props, ref) {
  const {
    title,
    text,
    variant,
    name = 'notification-banner',
    children,
  } = props;

  const [slugName] = useSlug(name);

  const cx = classes([styles.banner, styles[variant]], props);

  return (
    <div className={cx} data-component={slugName} ref={ref}>
      <div className={styles.bannerAttentionWrapper}>
        <span className={styles.bannerIcon}>{NotificationIcons[variant]}</span>
      </div>
      <div>
        <p className={styles.bannerTitle}>{title}</p>
        {text && (
          <p
            className={styles.bannerText}
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{ __html: text }}
          />
        )}
        {children}
      </div>
    </div>
  );
});
